import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from './components/layout/Layout'
import Home from './pages/Home'
import CreatePuzzle from './pages/CreatePuzzle'
import EditPuzzle from './pages/EditPuzzle'
import SolvePuzzle from './pages/SolvePuzzle'
import Leaderboard from './pages/Leaderboard'
import PrintView from './pages/PrintView'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="create" element={<CreatePuzzle />} />
        <Route path="create/:id" element={<EditPuzzle />} />
        <Route path="puzzle/:id" element={<SolvePuzzle />} />
        <Route path="puzzle/:id/leaderboard" element={<Leaderboard />} />
      </Route>
      <Route path="/puzzle/:id/print" element={<PrintView />} />
    </Routes>
  )
}
